export const WEBHOOK_PAYLOAD_MODEL_EMPTY_MESSAGE =
  'Selecione o tipo de disparo para ver o modelo do dado enviado';

export const WEBHOOK_PAYLOAD_EXAMPLES = {
  individual: {
    secret: 'f8c3de3d-1fea-4d7c-a8b0-29f63c4c3454',
    event: 'purchase_approved',
    data: {
      id: '87956abe-940e-4e8b-8a27-82c482920f64',
      refId: '9vbgfmg',
      customer: {
        name: 'John Doe',
        email: 'john.doe@example.com',
        phone: '34999999999',
        docNumber: '12345678909',
        birthDate: null,
        docType: 'cpf',
      },
      address: null,
      shipping: null,
      affiliate: 'affiliate@example.com',
      offer: {
        id: 'B8BcHrY',
        name: 'Special Offer',
        price: 100,
        image: null,
      },
      offer_type: 'main',
      product: {
        name: 'Produto Teste',
        id: 'ff3fdf61-e88f-43b5-982a-32d50f112414',
        short_id: 'AckhQ75',
        supportEmail: 'suporte@seudominio.com',
        type: 'unique',
        invoiceDescription: '',
      },
      checkout: 12345,
      subscription: null,
      subscription_period: 1,
      parent_order: null,
      checkoutUrl: 'https://pay.cakto.com.br/EXAMPLE',
      status: 'paid',
      baseAmount: 100.0,
      discount: 10.0,
      amount: 90.0,
      commissions: [
        {
          user: 'produtor@seudominio.com',
          totalAmount: 85.5,
          type: 'producer',
          percentage: 95,
        },
      ],
      fees: 4.5,
      couponCode: null,
      reason: null,
      refund_reason: null,
      installments: 1,
      paymentMethod: 'credit_card',
      paymentMethodName: 'Cartão de Crédito',
      paidAt: '2026-06-26T12:00:00.000000+00:00',
      createdAt: '2026-06-26T12:00:00.000000+00:00',
      due_date: null,
      refundedAt: null,
      chargedbackAt: null,
      canceledAt: null,
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_term: null,
      utm_content: null,
      sck: null,
      fbc: null,
      fbp: null,
      card: {
        lastDigits: '4323',
        holderName: 'Card Example',
        brand: 'visa',
      },
    },
  },
  grouped: {
    secret: 'f8c3de3d-1fea-4d7c-a8b0-29f63c4c3454',
    event: 'purchase_approved',
    data: [
      {
        id: '87956abe-940e-4e8b-8a27-82c482920f64',
        refId: '9vbgfmg',
        customer: {
          name: 'John Doe',
          email: 'john.doe@example.com',
          phone: '34999999999',
          docNumber: '12345678909',
          birthDate: null,
          docType: 'cpf',
        },
        address: null,
        shipping: null,
        affiliate: 'affiliate@example.com',
        offer: {
          id: 'B8BcHrY',
          name: 'Special Offer',
          price: 100,
          image: null,
        },
        offer_type: 'main',
        product: {
          name: 'Produto Teste',
          id: 'ff3fdf61-e88f-43b5-982a-32d50f112414',
          short_id: 'AckhQ75',
          supportEmail: 'suporte@seudominio.com',
          type: 'unique',
          invoiceDescription: '',
        },
        checkout: 12345,
        subscription: null,
        subscription_period: 1,
        parent_order: null,
        checkoutUrl: 'https://pay.cakto.com.br/EXAMPLE',
        status: 'paid',
        baseAmount: 100.0,
        discount: 10.0,
        amount: 90.0,
        commissions: [
          {
            user: 'produtor@seudominio.com',
            totalAmount: 85.5,
            type: 'producer',
            percentage: 95,
          },
        ],
        fees: 4.5,
        couponCode: null,
        reason: null,
        refund_reason: null,
        installments: 1,
        paymentMethod: 'credit_card',
        paymentMethodName: 'Cartão de Crédito',
        paidAt: '2026-06-26T12:00:00.000000+00:00',
        createdAt: '2026-06-26T12:00:00.000000+00:00',
        due_date: null,
        refundedAt: null,
        chargedbackAt: null,
        canceledAt: null,
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null,
        sck: null,
        fbc: null,
        fbp: null,
        card: {
          lastDigits: '4323',
          holderName: 'Card Example',
          brand: 'visa',
        },
      },
      {
        id: 'b1d7a0c2-5e3f-4a91-9c8d-6f2b1a4e7d90',
        refId: 'k7Xp2qB',
        customer: {
          name: 'John Doe',
          email: 'john.doe@example.com',
          phone: '34999999999',
          docNumber: '12345678909',
          birthDate: null,
          docType: 'cpf',
        },
        address: null,
        shipping: null,
        affiliate: 'affiliate@example.com',
        offer: {
          id: 'K2pQ9wL',
          name: 'E-book Bônus',
          price: 27,
          image: null,
        },
        offer_type: 'orderbump',
        product: {
          name: 'E-book Bônus',
          id: 'a9c0e51d-22b7-4f48-9a13-7e5d4c8b2f01',
          short_id: 'Bz9Lm3X',
          supportEmail: 'suporte@seudominio.com',
          type: 'unique',
          invoiceDescription: '',
        },
        checkout: 12345,
        subscription: null,
        subscription_period: 1,
        parent_order: '9vbgfmg',
        checkoutUrl: 'https://pay.cakto.com.br/EXAMPLE',
        status: 'paid',
        baseAmount: 27.0,
        discount: 0.0,
        amount: 27.0,
        commissions: [
          {
            user: 'produtor@seudominio.com',
            totalAmount: 25.65,
            type: 'producer',
            percentage: 95,
          },
        ],
        fees: 1.35,
        couponCode: null,
        reason: null,
        refund_reason: null,
        installments: 1,
        paymentMethod: 'credit_card',
        paymentMethodName: 'Cartão de Crédito',
        paidAt: '2026-06-26T12:00:00.000000+00:00',
        createdAt: '2026-06-26T12:00:00.000000+00:00',
        due_date: null,
        refundedAt: null,
        chargedbackAt: null,
        canceledAt: null,
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null,
        sck: null,
        fbc: null,
        fbp: null,
        card: {
          lastDigits: '4323',
          holderName: 'Card Example',
          brand: 'visa',
        },
      },
    ],
  },
};

export const getWebhookPayloadExample = (triggerType) => WEBHOOK_PAYLOAD_EXAMPLES[triggerType] || null;
